module.exports = __webpack_public_path__ + "img/icon_snake.fd34acb0.png";